import { AppointmentEligibilityReqProps } from 'services/appointments/appointments.types';
import { CheckPrescriptionEligibilityReqProps } from 'services/patientChart/patientChart.types';
import { CheckSurveysEligibilityReqProps } from 'services/surveys/surveys.types';

import { AppointmentTypeItem } from 'models/appointment.types';
import { ProgramCategory } from 'models/programs.types';

export const ELIGIBILITY_UNAVAILABLE = 'ELIGIBILITY_UNAVAILABLE' as const;
export type EligibilityUnavailable = typeof ELIGIBILITY_UNAVAILABLE;

export type ProgramPaywallReason =
  'appointment' | 'prescription' | 'survey' | 'onboarding' | 'add-to-cart';

// For appointments:
export type AppointmentEligibilityPayload = {
  type: 'appointment';
} & AppointmentEligibilityReqProps;

// For surveys:
export type SurveyEligibilityPayload = {
  type: 'survey';
} & CheckSurveysEligibilityReqProps;

// For prescriptions:
export type PrescriptionEligibilityPayload = {
  type: 'prescription';
} & CheckPrescriptionEligibilityReqProps;

// for onboarding / reonboarding
export type OnboardingEligibilityPayload = {
  type: 'onboarding';
} & ({ programCode: string } | { programCategory: ProgramCategory });

// for appointments during signup
export type AppointmentEligibilityAuthPayload = {
  type: 'appointment-auth';
} & {
  appointmentTypeCode: string;
};
export type GenericEligibilityCheckResponse = {
  data: {
    action:
      | {
          paywall:
            | {
                code: 'program_paywall';
                programCategory: ProgramCategory;
              }
            | {
                code: 'program_resume';
                programIds: string[];
              }
            | {
                code: 'billing_past_due';
              };
          type: 'SHOW_PAYWALL';
        }
      // WM appointment type and user is downgraded WM (FOR NOW ONLY FOR WM)
      | {
          link: string;
          type: 'OPEN_LINK';
        }
      // For the future. Will propose user to upgrade their plan later at checkout.
      // If yes - return 403 with actions.
      | {
          programIds: string[];
          type: 'CHECKOUT';
        };
    errors: unknown[]; // probably will be removed by backend
  };
};

// for now all return types are the same but let's keep them separate for future changes
export type CheckApptFnReturn = GenericEligibilityCheckResponse;
export type CheckSurveyFnReturn = GenericEligibilityCheckResponse;
export type CheckPrescriptionFnReturn = GenericEligibilityCheckResponse;
export type CheckOnboardingFnReturn = GenericEligibilityCheckResponse;
export type CheckApptAuthFnReturn = GenericEligibilityCheckResponse;

// depending on context we might need to pass additional data to the paywall handler
export type PaywallContext =
  | {
      appointmentType?: AppointmentTypeItem;
      ctx: 'appointment';
    }
  | {
      ctx: 'survey';
    }
  | {
      ctx: 'prescription';
    }
  | {
      ctx: 'onboarding';
    }
  | {
      ctx: 'add-to-cart';
    };
